import SectionRecord from "models/view-models/section-record";
import React from "react";

interface SectionDetailContentWithinPanelProps {
    sectionLabel: JSX.Element | undefined;
    cssBaseClass: string;

    section: SectionRecord;

    titleClassName: string;
}
const SectionDetailContentWithinPanel = (
    props: SectionDetailContentWithinPanelProps
) => {
    const { cssBaseClass, sectionLabel, section, titleClassName } = props;

    return (
        <React.Fragment>
            <span className={titleClassName}>
                <span>
                    {sectionLabel}
                    {section.getTitle()}
                </span>
            </span>
            <div className={`${cssBaseClass}__body`}>{section.getBody()}</div>
        </React.Fragment>
    );
};

export default SectionDetailContentWithinPanel;
